import { Box } from "@mui/material";
import React from "react";
import ComponentCategory from "./Categories/ComponentCategory";
import PageCategory from "./pageCategory/PageCategory";
import ScreenCategory from "./screenCategory/ScreenCategory";
import TypographyConstant from "./typography/Typography";
import PricingConstant from "./pricingSection/Pricing";

const Settings = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "auto",
        paddingY: "32px",
        paddingX: "98px",
        display: "flex",
        gap: "14px",
        flexDirection: "column",
      }}
    >
      <ComponentCategory />
      <PageCategory />
      <ScreenCategory />
      <TypographyConstant />
      <PricingConstant />
    </Box>
  );
};

export default Settings;
